module.exports = __webpack_public_path__ + "static/media/Logo musa formazione.1e37cc28.png";